import React, { useCallback } from 'react'

import { bool, func, string } from 'prop-types'

import { rememberAssetType } from 'Pods/SearchPage/Shared/RememberedAssetType/rememberedAssetType'
import { FILTER_NAME, getFeatureFilter, SELECTION_METHOD } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { setAssetType } from 'Pods/SearchPage/Store/actions/assetType'

import FilterChip from '../../../Shared/FilterChip/FilterChip'

// Never renders checked: the row only exists in "All", and a click leaves "All".
function ShortcutChip({
  chipKey, assetType, labelKey, subRowChipId, apply, isHiddenAtSm = false,
}) {
  const translate = useTranslate()
  const trackFilterSelect = useTrackFilterSelect()

  const handleChange = useCallback((nextChecked) => {
    if (!nextChecked) return

    // setAssetType resets the type's chips, so the filter is applied after it. Both writes land in
    // the same tick and share one fetch. The store is updated before tracking, so filter_select
    // reports the new content_type, as the type toggle does.
    setAssetType(assetType)
    apply()
    rememberAssetType(assetType)

    trackFilterSelect(FILTER_NAME.PRODUCT_TYPE_TOGGLE, assetType, SELECTION_METHOD.SHORTCUT)
    const { name, value } = getFeatureFilter(chipKey)
    trackFilterSelect(name, value)

    // This row unmounts with "All"; hand focus to the same filter in the sub-row that replaces it.
    // Triangle's Checkbox puts the id on its label and the chip id on the input's name.
    window.requestAnimationFrame(() => document.querySelector(`input[name="${subRowChipId}"]`)?.focus())
  }, [assetType, apply, chipKey, subRowChipId, trackFilterSelect])

  return (
    <FilterChip
      id={`quick-filter-${chipKey}`}
      label={translate(labelKey)}
      onChange={handleChange}
      isHiddenAtSm={isHiddenAtSm}
    />
  )
}

ShortcutChip.propTypes = {
  chipKey: string.isRequired,
  assetType: string.isRequired,
  labelKey: string.isRequired,
  subRowChipId: string.isRequired,
  apply: func.isRequired,
  isHiddenAtSm: bool,
}

export default ShortcutChip
